import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../SEO';
import {
  extractLegalMeta,
  parseLegalMarkdown,
  renderLegalBlock,
} from '../../utils/legalMarkdown';
import { OTHER_LEGAL_LINKS } from '../../content/legal/legalPages';

function LegalDocumentLayout({ page, children }) {
  const blocks = parseLegalMarkdown(page.markdown);
  const titleBlock = blocks.find((block) => block.type === 'h1');
  const documentTitle = titleBlock?.text || page.title;
  const meta = extractLegalMeta(page.markdown);
  const bodyBlocks = blocks.filter((block) => block.type !== 'h1');

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title={page.title}
        description={page.description}
        url={`/${page.slug === 'contact' ? 'contact' : page.slug}`}
      />

      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <header className="mb-8 border-b border-slate-200 pb-6">
          <h1 className="text-3xl font-serif font-bold text-slate-900 mb-4">
            {documentTitle}
          </h1>
          {meta.length > 0 && (
            <dl className="space-y-1 text-sm font-serif text-slate-600">
              {meta.map((item) => (
                <div key={item.label} className="flex flex-wrap gap-x-2">
                  <dt className="font-semibold text-slate-700">{item.label}:</dt>
                  <dd>{item.value}</dd>
                </div>
              ))}
            </dl>
          )}
        </header>

        <div className="font-serif text-slate-800 text-[15px] leading-relaxed">
          {bodyBlocks.map((block, index) => renderLegalBlock(block, index))}
        </div>

        {children}

        <footer className="mt-12 pt-6 border-t border-slate-200">
          <p className="text-sm font-serif text-slate-600 mb-3">
            &copy; 2026 Cognidoor
          </p>
          <nav
            className="flex flex-wrap gap-x-4 gap-y-2 text-sm font-serif"
            aria-label="Other legal pages"
          >
            {OTHER_LEGAL_LINKS.filter((link) => link.slug !== page.slug).map(
              (link) => (
                <Link
                  key={link.slug}
                  to={link.path}
                  className="text-blue-700 underline hover:text-blue-900"
                >
                  {link.title}
                </Link>
              )
            )}
          </nav>
        </footer>
      </article>
    </div>
  );
}

export default LegalDocumentLayout;
